import { Entity } from '../../Model/Implementation/Entity';
import { EntityValidationOptions } from './EntityValidationOptions';
import validateEntity from './validateEntity';

export default function isEntityValid(entity: Entity,
                                      partialOptions?: Partial<EntityValidationOptions>): boolean
{
    return validateEntity(entity, partialOptions).isValid;
}
